import React from "react";
import { observer } from "mobx-react";
import { THEME_SETTINGS } from "@theme-settings";
import { useRootAppStore } from "@hooks";
import HeaderBonusAnnouncement from "./HeaderBonusAnnouncement";
import HeaderLockButton from "./HeaderLockButton";
import HeaderWelcome from "./HeaderWelcome";

export default observer(function HeaderTop() {
	const { userAuthStore } = useRootAppStore();

	if (!userAuthStore.isLoggedIn) {
		return <HeaderBonusAnnouncement />;
	}

	if (THEME_SETTINGS.isOasisEnabled || THEME_SETTINGS.is24hLockEnabled) {
		return <HeaderLockButton />;
	}

	return <HeaderWelcome />;
});
